import { WithdrawalsResetExchangeRatesProcessedItemsReducer } from './types';

export const withdrawalsResetExchangeRatesProcessedItemsReducer: WithdrawalsResetExchangeRatesProcessedItemsReducer =
  (state) => {
    return {
      ...state,
      withdrawalsExchangeRatesProcessedItems: {
        ...(state.withdrawalsExchangeRates?.items ?? undefined),
      },
    };
  };
